import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
}

export default function PageHero({ title, subtitle, crumbs }: PageHeroProps) {
  return (
    <div className="w-full bg-primary-950 relative overflow-hidden">
      <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-primary-800/50"></div>
      <div className="absolute right-40 bottom-0 w-32 h-32 rounded-full bg-accent-500/20"></div>
      <div className="relative w-full px-4 md:px-8 py-10 md:py-14">
        {crumbs && crumbs.length > 0 && (
          <nav className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-background-300 mb-3">
            {crumbs.map((c, i) => (
              <span key={`${c.label}-${i}`} className="flex items-center gap-2">
                {i > 0 && <i className="ri-arrow-right-s-line text-background-500"></i>}
                {c.to ? (
                  <Link to={c.to} className="hover:text-accent-400 transition-colors cursor-pointer">
                    {c.label}
                  </Link>
                ) : (
                  <span className="text-background-100">{c.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="text-2xl md:text-4xl font-bold text-background-50">{title}</h1>
        {subtitle && (
          <p className="mt-3 text-sm md:text-base text-background-300 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}